import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Grid, CircularProgress, Slider } from '@material-ui/core';
import { CheckCircleOutlineSharp, HighlightOffSharp } from '@material-ui/icons';
import { InstallPaper, InstallBox, InstallSwitch, Header, Label, RefreshButton } from './parts';
import { getGridSetting, sendGridSetting } from '../../../actions/installation/gridActions'

const StatusIcon = ({ status }) => {
    return status ? <CheckCircleOutlineSharp style={{ color: "green" }} /> : <HighlightOffSharp style={{ color: "red" }} />
}


export function GridExport({ readonly }) {
  const dispatch = useDispatch();
  const settings = useSelector(state => state.installation.grid.setting);
  const loading = useSelector(state => state.installation.grid.settingLoading);
  const [sliderValue, setSliderValue] = useState(0);
  const setting = settings.find(x => x.parameter === 'export_limit');
  const enabled = setting?setting.data.value!==null:false;
  const sliderMarks = [{value: 0, label: '0'}, {value: 5000, label: '5kW'}, {value: 10000, label: '10kW'}];
    

  useEffect(() => {
    dispatch(getGridSetting('export_limit'));
  }, [dispatch]);

  useEffect(() => {
    if (setting) {
      setSliderValue(Math.abs(setting.data.value));
    } 
  }, [settings, setting]);

  function handleRefresh() {
    dispatch(getGridSetting('export_limit'));
  }

  function handleSwitch(e) {
    dispatch(sendGridSetting(setting.parameter, {value: (e.target.checked?5000:null)}));
  }

  function handleSlider(value) {
    dispatch(sendGridSetting(setting.parameter, {value: value}));
  }

  function renderValue() {
    if (!setting) {
      return null;
    }
    return (
      setting.data.value
    );
  }

  return (
    <InstallPaper>
      <Header>
        Export Limit
        {loading?<CircularProgress size={16}/>:<RefreshButton onClick={handleRefresh}/>}
      </Header>
      <InstallBox>
        <Grid container justify="space-between" alignItems="center" spacing={0}>
          <Grid item xs={9}>
            <Label>Enable</Label>
          </Grid>
          <Grid item xs={3} align="right">
            {setting ? <>
              {readonly ? 
                <StatusIcon status={setting.data.value} /> : 
                <InstallSwitch
                  name={setting.data.id}
                  size="small"
                  checked={enabled}
                  onChange={(e) => handleSwitch(e)}
                  disabled={loading}
                />
              }
            </>
             : null}
          </Grid>
        </Grid>
      </InstallBox>
      {enabled?<InstallBox>
        <Grid container justify="space-between" alignItems="center" spacing={0}>
          <Grid item xs={6}>
            <Label>Limit</Label>
          </Grid>
          <Grid item xs={4}>
            <Slider
              value={sliderValue}
              step={250}
              min={0}
              max={10000}
              marks={sliderMarks}
              valueLabelDisplay="auto"
              onChange={(e, val) => setSliderValue(val)}
              onChangeCommitted={(e, val) => handleSlider(val)}
              disabled={loading || readonly}
            />
          </Grid>
          <Grid item align="right" xs={2}>
            {loading?<CircularProgress size={16}/>
              :<Label>{renderValue()} W</Label>}
          </Grid>
        </Grid>
      </InstallBox>:null}
    </InstallPaper>
  );
};
